import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/datascienceimages/tool/KNIME.png";
import two from "../../assets/datascienceimages/tool/Tableau.png";
import three from "../../assets/datascienceimages/tool/jupyter.png";
import four from "../../assets/datascienceimages/tool/keras.png";
import five from "../../assets/datascienceimages/tool/matplotlib.png";
import six from "../../assets/datascienceimages/tool/numpy.png";
import seven from "../../assets/datascienceimages/tool/pandas.png";
import eight from "../../assets/datascienceimages/tool/pyspark.png";
import nine from "../../assets/datascienceimages/tool/python.png";
import ten from "../../assets/datascienceimages/tool/scikitlearn.png";
import elven from "../../assets/datascienceimages/tool/seaborn.png";
import twele from "../../assets/datascienceimages/tool/streamlit.png";
import thirteen from "../../assets/datascienceimages/tool/tensorflow.png";


const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
  { src: thirteen, alt: "TestNG" },

];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
            Gain hands-on experience with the most in-demand tools used by
            Data Sience professionals.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
